
import { MapLocation } from '@/types/location';

// ProMaker Gym Locations
export const proMakerGyms: MapLocation[] = [
  {
    id: 10001,
    name: "ProMaker Gym - Jeddah (Al Naseem)",
    type: "Gym",
    devices: 3,
    coordinates: [21.520325146801436, 39.23268696441765],
    region: "Jeddah",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Male",
    ageRange: "18-50",
    orientation: "Portrait",
    segment: "Fitness"
  }
];
